export const OPS_SPORTS = ["mlb", "nba", "nfl"];
export const OPS_JOBS = ["smart-sync", "greats-rebuild", "similarity-build"];
export const OPS_STATUSES = ["ok", "skipped", "partial", "failed"];

export const OPS_STATUS_CHIP = {
  ok: "success",
  skipped: "default",
  partial: "warning",
  failed: "error",
};

export function formatOpsMetrics(metrics = {}) {
  const parts = [];
  if (metrics.gamesProcessed != null) {
    parts.push(`${metrics.gamesProcessed} games`);
  }
  if (metrics.playersSynced != null) {
    parts.push(`${metrics.playersSynced} players`);
  }
  if (metrics.collectionsTouched?.length) {
    parts.push(`${metrics.collectionsTouched.length} collections`);
  }
  if (metrics.documentsWritten != null) {
    parts.push(`${metrics.documentsWritten} docs`);
  }
  return parts.join(" · ") || "—";
}

export function formatOpsDuration(durationMs) {
  if (!durationMs) return "—";
  const totalSeconds = Math.round(durationMs / 1000);
  if (totalSeconds < 60) return `${totalSeconds}s`;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return seconds ? `${minutes}m ${seconds}s` : `${minutes}m`;
}

export function buildOpsRunsQuery({
  sport,
  job,
  status,
  from,
  to,
  page = 0,
  pageSize = 25,
} = {}) {
  const params = new URLSearchParams();
  if (sport) params.set("sport", sport);
  if (job) params.set("job", job);
  if (status) params.set("status", status);
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  params.set("page", String(page + 1));
  params.set("pageSize", String(pageSize));
  return `/admin/ops/runs?${params.toString()}`;
}
